import api from '../api'

export default {
  state: {
    accessToken: window.localStorage.getItem('accessToken'),
    refreshToken: window.localStorage.getItem('refreshToken')
  },
  getters: {
    isLoggedIn(state) {
      return !!state.accessToken
    },
    accessToken(state) {
      return state.accessToken
    },
    refreshToken(state) {
      return state.refreshToken
    }
  },
  mutations: {
    setAccessToken(state, token) {
      state.accessToken = token
      window.localStorage.setItem('accessToken', token)
    },
    setRefreshToken(state, token) {
      state.refreshToken = token
      window.localStorage.setItem('refreshToken', token)
    },
    logout(state) {
      state.accessToken = null
      state.refreshToken = null

      window.localStorage.removeItem('refreshToken')
      window.localStorage.removeItem('accessToken')
    }
  },
  actions: {
    async login({ commit }, { username, password }) {
      const response = await api.post(`${process.env.VUE_APP_ADMIN_URL}/oauth/token`, {
        client_id: process.env.VUE_APP_CLIENT_ID,
        client_secret: process.env.VUE_APP_CLIENT_SECRET,
        grant_type: 'password',
        username,
        password
      })

      const data = response.data

      commit('setAccessToken', data.access_token)
      commit('setRefreshToken', data.refresh_token)
    },
    async refresh({ getters, commit }) {
      const refreshToken = getters.refreshToken

      const response = await api.post(`${process.env.VUE_APP_ADMIN_URL}/oauth/token`, {
        client_id: process.env.VUE_APP_CLIENT_ID,
        client_secret: process.env.VUE_APP_CLIENT_SECRET,
        grant_type: 'refresh_token',
        refresh_token: refreshToken
      })

      const data = response.data

      commit('setAccessToken', data.access_token)
      commit('setRefreshToken', data.refresh_token)
    },
    async logout({ commit }) {
      commit('logout')
    },
    async requestPasswordReset(context, { email }) {
      const response = await api.post('password/email', { email })

      return response
    },
    async resetPassword(context, credentials) {
      const response = await api.post('password/reset', credentials)
    }
  }
}